module.exports = __webpack_public_path__ + "img/missing_toilet_paper.e26fdb09.svg";